// The Amplitude Web Experiment treatment injects a marker element into the page; the control
// variant injects nothing. When it lands depends on the network (the SDK fetches its remote
// config first), so the page is observed for as long as it lives rather than polled for a
// bounded time.
export const SIGNUP_EXPERIMENT_TRIGGER_ID = 'signup-chatbot-trigger'

/** Calls `onActivate` once, as soon as the marker exists. Returns a stop function. */
export function watchSignupExperimentTrigger(
  onActivate: () => void,
  { root = document }: { root?: Document } = {},
): () => void {
  const present = () => root.getElementById(SIGNUP_EXPERIMENT_TRIGGER_ID) !== null
  if (present()) {
    onActivate()
    return () => {}
  }
  const observer = new MutationObserver(() => {
    if (!present()) return
    observer.disconnect()
    onActivate()
  })
  // documentElement, not body: Turbo replaces <body> on navigation and would orphan the observer.
  observer.observe(root.documentElement, { childList: true, subtree: true })
  return () => observer.disconnect()
}
